// const api = "http://localhost:1338/api";
// const host = "http://localhost:1338";

const api = "https://syn-pro-api.wsio-api.com/api";
const host = "https://syn-pro-api.wsio-api.com";

const apiShop = "https://howardson-api.wsio-api.com/api";
const hostShop = "https://howardson-api.wsio-api.com";

const locales = [];
const loqateKey = "AY75-WB66-NW49-BF43";

export { api, apiShop, host, hostShop, locales, loqateKey };